enum SubCategoryListEvents {
  SubCategoryItemClick = 'catalog_subcategory_tap',
}

export default SubCategoryListEvents
